/* eslint-disable import/no-default-export */
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {SliderGalleryControllerFlowEditor} from '../../viewerScript/SliderGalleryControllerFlowEditor';

export default controllerFactory(SliderGalleryControllerFlowEditor);
